import type { FC } from 'react';

import { Button, Row, Typography } from 'enable-ui';

import { ReactComponent as AddIcon } from 'assets/icons/add.svg';

import { COLOR } from 'constants/color';

import { CustomButton, HeaderWrapper } from './style';

export const HeaderPage: FC<{
  title: string;
  onClick?: () => void;
  titleButton?: string;
  hideButton?: boolean;
  extraContent?: React.ReactNode;
  extraButton?: React.ReactNode;
}> = ({ title, onClick, titleButton, hideButton, extraContent, extraButton }) => {
  return (
    <HeaderWrapper>
      <Typography
        variant="h3"
        weight={500}
        className="whitespace-nowrap"
        color={COLOR.surfaceNeutralBold['neutral-11']}
      >
        {title}
      </Typography>
      {!hideButton && (
        <Row style={{ gap: 16, justifyContent: 'flex-end' }}>
          {extraContent}
          {extraButton ?? (
            <CustomButton>
              <Button
                icon={<AddIcon style={{ marginRight: 4, width: 20, height: 20 }} />}
                placementIcon="left"
                onClick={onClick}
              >
                {titleButton ?? 'Add'}
              </Button>
            </CustomButton>
          )}
        </Row>
      )}
    </HeaderWrapper>
  );
};
